import { render, staticRenderFns } from "./index.vue?vue&type=template&id=56834fca&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56834fca')) {
      api.createRecord('56834fca', component.options)
    } else {
      api.reload('56834fca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=56834fca&", function () {
      api.rerender('56834fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/permission/index.vue"
export default component.exports